interface ErrorMap {
  [key: string]: string;
}

const errorMap: ErrorMap = {
  '200': 'Card Name',
  '310': 'Card Number',
  '315': 'Card Number',
  '320': 'Card Number',
  '330': 'Expiration month left blank.',
  '340': 'Expiration year left blank.',
  '355': 'CVC',
  '357': 'CVC',
  '370': 'Expiry Date',
  '530': 'Postal Code',
  '531': 'Invalid ZIP/postal code format received.',
};

export const getErrors = (codes: string[]): string[] => codes.map(code => errorMap[code] || 'Unknown error');

export class FormErrors{
  public errorCode: string[] = [];
}